import React from 'react';

import { Theme, createStyles, withStyles } from '@material-ui/core';
import { Button } from '@material-ui/core';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import { RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import { RadioButtonUnchecked, RadioButtonChecked } from '@material-ui/icons';

import ForwarderModel from '../../../../../models/ForwarderAwb';

const styles = (theme: Theme) =>

  createStyles({
    dialogTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingBottom: '10px',
      color: 'var(--primaryblue)',
      fontSize: '22px',
      borderBottom: '2px solid #adadad'
    },
    dialogContent: {
      paddingTop: '24px'
    },    
    close: {
      fontSize: '20px'
    },
    mContent: {
      fontSize: '15px',
      marginTop: '0px',
    },
    submitBtn: {
      fontSize: '13px',
      marginLeft: '8px',
    },
    dialogContentRadio: {
      maxHeight: '150px',
      overflow: 'auto',
      marginBottom: '10px',
    },
    radioContainer: {
      marginBottom: '40px'
    },
    radioBtn: {
      padding: '0 10px 0 20px',
    },
    radioIcon: {
      fontSize: '18px'
    },
    radioLabel: {
      paddingBottom: '10px'
    },
    mfooterContent: {
      marginTop: '20px',
      '& button': {
        margin: 0,
        display: 'flex',
        marginLeft: 'auto !important'
      }
    }   
  });

interface CreateForwarderProps {
  classes: any;
  modalOpen: boolean;
  handleCloseFwdModal: () => void;
  relevantForwarders: Array<ForwarderModel>;
  forwarderInput: string;
  stationInput: string;
  selectedForwarder: string;
  selectedForwarderLocationValue: string;
  handleSelectForwarder: (event: any) => void;
  handleAddSelForwarder: () => void;
  handleAddNewFwd: () => void;
};

interface Option {
  value: number;
  label: string;
};

const createForwarder = (props: CreateForwarderProps) => {

  const { classes } = props;
  const relevantFwdOptions: Array<Option> = props.relevantForwarders.map((item: any) => (
    {
      value: item.forwarder_location_id,
      label: item.name
    }
  ));
  const relevantFwdRadio = relevantFwdOptions.map((item, j) => {
    return(<FormControlLabel 
      key={ j } 
      value={ item.value.toString() } 
      className={classes.radioLabel}
      control={ 
        <Radio 
        className={classes.radioBtn}
        icon={ <RadioButtonUnchecked className={classes.radioIcon} color='primary' /> }
        checkedIcon={ <RadioButtonChecked className={classes.radioIcon} color='primary' /> }
        /> 
      } 
      label={ item.label } 
    />);
  });      

  return(
    <Dialog
      open={ props.modalOpen }        
      aria-labelledby="form-dialog-title"
      maxWidth={ 'md' }
      disableBackdropClick
      disableEscapeKeyDown        
    >
      <DialogTitle id="form-dialog-title">
        <div className={ classes.dialogTitle }>
          <span>Recheck Forwarder Name</span>
          <IconButton aria-label="Close" onClick={ props.handleCloseFwdModal} className={ classes.close }>
            <CloseIcon color='primary' fontSize='inherit'/>
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent className={ classes.dialogContent }>
        <p className={ classes.mContent }>It appears that the forwarder you are trying to add may already be in the list.</p>
        <p className={ classes.mContent }>Please check the entries below and select accordingly :</p>
        <div className={classes.radioContainer}>
          <div className={classes.dialogContentRadio}>
            <RadioGroup
              name="forwarderName"
              value={ props.selectedForwarderLocationValue }
              onChange={ props.handleSelectForwarder }
              >
              { relevantFwdRadio }
            </RadioGroup>
          </div>
          <Button  
            className={ classes.submitBtn }                      
            variant="contained"
            disabled={ !props.selectedForwarderLocationValue ? true : false }
            onClick={ props.handleAddSelForwarder } 
            color="primary">Use selected Forwarder
          </Button>
        </div>
        <div className={classes.mfooterContent}>
          <p className={ classes.mContent }>If none of the above entires match, You may proceed to add <b>"{ props.forwarderInput }"</b> as a new forwarder</p>
          <Button  
            className={ classes.submitBtn }                      
            variant="contained"
            onClick={ props.handleAddNewFwd } 
            color="primary">Add as a new Forwarder
          </Button>
        </div>
      </DialogContent>           
    </Dialog>
  );
};

export default withStyles(styles)(createForwarder);